import React from "react";
import { useSelector } from "react-redux";
import "./Layout.scss";
import BottomNavBar from "./LayoutComponents/BottomNavBar";
import Header from "./LayoutComponents/Header";

function Layout({
  children,
  title,
  header = true,
  bottomNavBar = true,
  needsDatePicker = false,
  showLocations = true,
}) {
  const identifyInfo = useSelector((state) => state.login?.identifyInfo?.data);

  return (
    <div
      className="layout-container"
      // style={{
      //   backgroundImage:
      //     title === "Login"
      //       ? `url(${identifyInfo?.background})`
      //       : `url(${backgroundImageOther})`,
      // }}
    >
      {header && <Header title={title} needsDatePicker={needsDatePicker} />}
      <main
        className="main fadeInDelayed"
        style={{
          marginTop: header ? (needsDatePicker ? "9rem" : "5rem") : "2rem",
          paddingBottom: bottomNavBar ? "5rem" : null,
          // backgroundColor: title === "Login" ? null : "var(--background-color)",
        }}
      >
        <>{children}</>
      </main>
      {bottomNavBar && <BottomNavBar />}
    </div>
  );
}

export default Layout;
